module.exports = __webpack_public_path__ + "static/media/me.e012e2c8.svg";